import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    events: {data:[]},
    joinedEvents: {},
    pendingEvents: {},
    interestedEvents: {},
    invitations: null
  },
  mutations: {
    setAllEvents (state, v) {
      Vue.set(state, 'events', v)
    },
    setEventInvitations (state, v) {
      Vue.set(state, 'invitations', v)
    },
    setJoinEvents (state, v) {
      Vue.set(state, 'joinedEvents', v)
    },
    setPendingEvents (state, v) {
      Vue.set(state, 'pendingEvents', v)
    },
    setInterestedEvents (state, v) {
      Vue.set(state, 'interestedEvents', v)
    }
  },
  actions: {
    getListOfEvents ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/joined/events?filter=status:' + payload).then(res => {
          if(payload == 'accepted'){            
            commit('publicProfile/setUserGroupType', {type:'event', data:res.data}, { root: 1 })
            commit('setJoinEvents', res.data)
          }else if(payload == 'pending'){
            commit('setPendingEvents', res.data)
          }
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    getInterestedEvents ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/interested/events').then(res => {
          commit('setInterestedEvents', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    getAllEvents ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.mainbrand + '/' + payload + '/event ').then(res => {
          commit('setAllEvents', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },    
    getSingleEvents ({ commit, dispatch, state }, {payload,event_id}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.mainbrand + '/' + payload + '/event/' + event_id).then(res => {
          commit('setAllEvents', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    getEventInvites ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.event + '/' + payload + '/invites').then(res => {
          commit('setEventInvitations', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    declineEvent ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.event + '/' + payload + '/decline').then(res => {
          commit('resource/updateEventSubscribeStatus', res.data.data.status, { root: 1 })
          commit('resource/updateEventSubscribeInviteId', null, { root: 1 })
          commit("resource/updateGroupSubscribeStatus", false, { root: 1 });
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    joinEvent ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.event + '/' + payload + '/join').then(res => {
          commit('resource/updateEventSubscribeStatus', res.data.data.status, { root: 1 })
          commit('resource/updateEventSubscribeInviteId', res.data.id, { root: 1 })
          commit("resource/updateGroupSubscribeStatus", true, { root: 1 });
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    inviteUserEvent ({ commit, dispatch, state }, {payload,user_id}) {
      return new Promise((resolve, reject) => {
        var param = {
          user_id: user_id
        };
        Axios.post(API.endpoints.event + '/' + payload + '/invite',param).then(res => {
          // commit('setEventInvitations', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    },
    setInterestedEvent ({ commit, dispatch, state }, id) {
      return new Promise((resolve, reject) => {
        Axios.put(API.endpoints.event + '/invite/' + id + '/interested').then(res => {
          commit('resource/updateEventSubscribeStatus', res.data.data.status, { root: 1 })
          commit('resource/updateEventSubscribeInviteId', null, { root: 1 })
          commit("resource/updateGroupSubscribeStatus", true, { root: 1 });
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
        })
      })
    }
  }
}
